module.exports = __webpack_public_path__ + "956d9c6727e09eb3cbebfa58f6892b60.png";